import { Injectable } from "@angular/core";

const UNITS: string[] = [
  "bytes",
  "kB",
  "MB",
  "GB",
  "TB",
  "PB",
  "EB",
  "ZB",
  "YB"
];

@Injectable()
export class FileSizeService {
  transform(input: string | number): string {
    // sourced from: https://github.com/sindresorhus/pretty-bytes/blob/6df9e3db4bebcaedd527b0449bb0baca0b1e54f0/index.js
    let fileSizeInBytes: number = Number(input);

    if (!Number.isFinite(fileSizeInBytes)) {
      return "n/a";
    }

    const neg = fileSizeInBytes < 0;

    if (neg) {
      fileSizeInBytes = -fileSizeInBytes;
    }

    if (fileSizeInBytes < 1) {
      return (neg ? "-" : "") + fileSizeInBytes + " bytes";
    }

    const exponent = Math.min(
      Math.floor(Math.log(fileSizeInBytes) / Math.log(1000)),
      UNITS.length - 1
    );
    const numStr = Number(
      (fileSizeInBytes / Math.pow(1000, exponent)).toPrecision(3)
    );
    const unit = UNITS[exponent];

    return (neg ? "-" : "") + numStr + " " + unit;
  }
}
